module.exports = __webpack_public_path__ + "img/15.9abd4b8f.png";